
interface LibraryResultsCountProps {
  isLoading: boolean;
  isCountLoading: boolean;
  totalCount: number;
  viewMode: "recipes" | "creators";
}

export const LibraryResultsCount = ({
  isLoading,
  isCountLoading,
  totalCount,
  viewMode,
}: LibraryResultsCountProps) => {
  if (isLoading || isCountLoading) {
    return <h2 className="text-2xl font-semibold">Loading...</h2>;
  }

  return (
    <h2 className="text-2xl font-semibold">
      {`${totalCount || 0} ${viewMode === "recipes" ? "recipes" : "creators"} found`}
    </h2>
  );
};
